import { useState, type FormEvent } from 'react';
import type { EventItem } from '../types';
import { registerForEvent, submitGreeting, submitMemory } from '../lib/repository';
import { Check, Upload, X } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { firebaseConfigured } from '../lib/firebase';

export function EventRegistrationModal({ event, onClose }: { event?: EventItem; onClose: () => void }) {
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!event) return null;
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault(); setBusy(true);
    const f = new FormData(e.currentTarget);
    await registerForEvent({ eventId:event!.id, eventTitle:`${event!.series} · ${event!.title}`, name:String(f.get('name')), email:String(f.get('email')), raffleOptIn:Boolean(f.get('raffle')), consent:Boolean(f.get('consent')) });
    setBusy(false); setSent(true);
  }
  return <div className="modal-backdrop" role="dialog" aria-modal="true">
    <div className="modal">
      <button className="modal-close" onClick={onClose}><X size={20}/></button>
      {!sent ? <>
        <p className="eyebrow">Preinscripción</p><h3>{event.series}</h3><p className="muted">{event.title} · {event.dateLabel}</p>
        <form className="form" onSubmit={submit}>
          <label>Nombre completo<input name="name" required /></label>
          <label>Correo electrónico<input type="email" name="email" required /></label>
          <label className="check"><input type="checkbox" name="raffle" /> Deseo participar de sorteos vinculados al evento.</label>
          <label className="check"><input type="checkbox" name="consent" required /> Acepto recibir información sobre esta actividad y el tratamiento de mis datos para la inscripción.</label>
          <button className="btn btn-gold" disabled={busy}>{busy ? 'Enviando...' : 'Enviar preinscripción'}</button>
        </form>
      </> : <div className="sent"><Check/><h3>Registro recibido</h3><p>Te contactaremos cuando la fecha y condiciones estén confirmadas.</p><button className="btn" onClick={onClose}>Cerrar</button></div>}
    </div>
  </div>;
}

export function GreetingForm() {
  const [sent, setSent] = useState(false);
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    await submitGreeting({ name:String(f.get('name')), message:String(f.get('message')) }); setSent(true); e.currentTarget.reset();
  }
  return <form className="form memory-form" onSubmit={submit}>
    <label>Tu nombre<input name="name" required /></label>
    <label>Tu saludo<textarea name="message" rows={4} maxLength={500} required /></label>
    <button className="btn btn-gold">Enviar para moderación</button>
    {sent && <p className="form-status">Gracias. El mensaje será revisado antes de publicarse.</p>}
  </form>;
}

export function SharedMemoryForm() {
  const [sent, setSent] = useState(false);
  const { user, signIn } = useAuth();
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (firebaseConfigured && !user) { await signIn(); return; }
    const f = new FormData(e.currentTarget); const input = e.currentTarget.elements.namedItem('image') as HTMLInputElement;
    await submitMemory({ name:String(f.get('name')), story:String(f.get('story')), file:input.files?.[0] }); setSent(true); e.currentTarget.reset();
  }
  return <form className="form memory-form" onSubmit={submit}>
    <label>Tu nombre<input name="name" required /></label>
    <label>Contanos el momento<textarea name="story" rows={4} maxLength={700} required /></label>
    <label className="upload"><Upload size={16}/> Subir imagen compartida<input className="visually-hidden" name="image" type="file" accept="image/jpeg,image/png,image/webp" /></label>
    {firebaseConfigured && !user ? <button type="button" className="btn btn-gold" onClick={() => signIn()}>Ingresar con Google para subir</button> : <button className="btn btn-gold">Enviar recuerdo</button>}
    {sent && <p className="form-status">Recibido. La fotografía y el texto quedan pendientes de moderación.</p>}
  </form>;
}
